import { NgModule } from '@angular/core';

import { MyAccountComponent } from './my-account.component';
import { EffectsModule } from '@ngrx/effects';
import { RouterModule } from '@angular/router';
import { myAccountRoutes } from './my-account.routes';
import { BillingComponent } from './billing/billing.component';
import { TranslateModule } from '@ngx-translate/core';
import { LayoutModule } from '../shared/layout/layout.module';
import { PlanComponent } from './plan/plan.component';
import { BillingInformationComponent } from './billing/billing-information/billing-information.component';
import { InvoicesComponent } from './billing/invoices/invoices.component';
import { MatSortModule, MatTableModule } from '@angular/material';
import { InvoicesResolve } from './billing/invoices/invoices.resolve';
import { InvoicesService } from './billing/invoices/invoices.service';
import { StoreModule } from '@ngrx/store';
import { invoicesReducer } from './billing/invoices/invoices.reducer';
import { InvoicesEffects } from './billing/invoices/invoices.effects';
import { InvoicesTableDataSource } from './billing/invoices/invoices.table.data';
import { MomentModule } from 'ngx-moment';
import { BrowserModule } from '@angular/platform-browser';
import { SharedModule } from '../shared/shared.module';
import { ChoosePlanComponent } from './choose-plan/choose-plan.component';
import { UiSwitchModule } from 'ngx-ui-switch';
import { UI_SWITCH_CONFIGURATION } from '../shared/utils/layoutUtils';
import { BalanceComponent } from './plan/balance/balance.component';
import { MoneyPackageCardComponent } from './plan/balance/money-package-card/money-package-card.component';
import { CancelAccountComponent } from './plan/cancel-account/cancel-account.component';
import { CurrentPlanComponent } from './plan/current-plan/current-plan.component';
import { PhoneNumbersPlanComponent } from './plan/phone-numbers-plan/phone-numbers-plan.component';
import { AccountSettingsService } from './account-settings.service';
import { CardComponent } from './plan/card/card.component';
import { BillingService } from './billing/billing.service';
import { BillingResolve } from './billing/billing.resolve';
import { billingReducer } from './billing/billing.reducer';
import { BillingEffects } from './billing/billing.effects';
import { ChooseAccountBlockedComponent } from './choose-account-blocked/choose-account-blocked.component';
import { PlansTableComponent } from './choose-plan/plans-table/plans-table.component';
import { PlansPanelComponent } from './choose-plan/plans-panel/plans-panel.component';
import { PlanBriefHeaderComponent } from './choose-plan/plan-brief-header/plan-brief-header.component';
import { PlanFeaturesTableComponent } from './choose-plan/plan-features-table/plan-features-table.component';
import { ChangePlanConfirmationComponent } from './choose-plan/change-plan-confirmation/change-plan-confirmation.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CurrentSubscriptionInfoComponent } from './choose-plan/current-subscription-info/current-subscription-info.component';
import { ChangePlanSummaryDialogComponent } from './choose-plan/change-plan-summary/change-plan-summary-dialog.component';
import { PlanBriefTableComponent } from './choose-plan/change-plan-summary/plan-brief-table/plan-brief-table.component';
import { WebcallBalanceComponent } from './plan/balance/webcall-balance/webcall-balance.component';

@NgModule({
  declarations: [
    BillingComponent,
    InvoicesComponent,
    MyAccountComponent,
    PlanComponent,
    BillingInformationComponent,
    ChoosePlanComponent,
    BalanceComponent,
    MoneyPackageCardComponent,
    CancelAccountComponent,
    CurrentPlanComponent,
    PhoneNumbersPlanComponent,
    CardComponent,
    ChooseAccountBlockedComponent,
    PlansTableComponent,
    PlansPanelComponent,
    PlanBriefHeaderComponent,
    PlanFeaturesTableComponent,
    ChangePlanConfirmationComponent,
    CurrentSubscriptionInfoComponent,
    ChangePlanSummaryDialogComponent,
    PlanBriefTableComponent,
    WebcallBalanceComponent
  ],
  imports: [
    BrowserModule,
    TranslateModule,
    LayoutModule,
    MatTableModule,
    MatSortModule,
    MomentModule,
    RouterModule.forChild(myAccountRoutes),
    SharedModule,
    StoreModule.forFeature('billing', {
      invoices: invoicesReducer,
      billingInformation: billingReducer
    }),
    EffectsModule.forFeature([InvoicesEffects, BillingEffects]),
    UiSwitchModule.forRoot(UI_SWITCH_CONFIGURATION),
    MatTooltipModule
  ],
  providers: [
    InvoicesTableDataSource,
    InvoicesService,
    InvoicesResolve,
    BillingService,
    BillingResolve,
    AccountSettingsService
  ],
  exports: [MyAccountComponent, CardComponent],
  entryComponents: [ChangePlanConfirmationComponent, ChangePlanSummaryDialogComponent]
})
export class MyAccountModule {}
